/* eslint-disable import/no-dynamic-require, padded-blocks, prefer-template */
/* global Promise, process */

import scriptjs from 'scriptjs';

import localCache from '../services/LocalCache';
import navigationService from '../services/NavigationService';
import { t } from '../services/i18nService';
import alertService from '../services/AlertService';
import utilService from '../services/UtilService';

import apiActions from '../actions/ApiActions';
import assessmentActions from '../actions/AssessmentActions';
import settingsActions from '../actions/SettingsActions';
import sessionActions from '../actions/SessionActions';
import sessionConstants from '../constants/SessionConstants';

import storeManager from '../store/StoreManager';
import connectionStatusConstants from '../constants/ConnectionStatusConstants';
import sessionCache from '../services/SessionCache';

const offlineDataLoader = {
    loadInitialData() {
        const sessionStorageData = JSON.parse(sessionCache.getItem('offlineCandidate'));

        const startTest = Object.assign({
            autoDeliveringEnabled: false,
            autoDeliverWithManualEnabled: false,
            demoExam: false,
            invigilatorPassword: window.invigilatorPassword,
            passesLockDownRequirements: true,
            requireLockDownBrowser: false,
            requireLockDownChromeKiosk: false,
            startTime: utilService.getIsoDateStamp(),
            userHasChromeKiosk: false,
            userHasSeb: false,
        }, sessionStorageData);

        scriptjs(['testData/assessmentContent.js', 'testData/candidatesInfo.js'], () => {
            const { values } = window.offlineSettings;
            values.spell_checker_disabled = true;

            const marketplaceProperties = window.marketplaceProperties || {};
            const allSettings = Object.assign({ marketplaceProperties }, { values });

            const assessment = window.offlineQuestionSet;
            storeManager.dispatch(sessionActions.setContext(sessionConstants.CONTEXT_EXAM));
            storeManager.dispatch(sessionActions.setRequestParameterIds({
                assessmentRunId: window.offlineQuestionSet.assessmentRunId,
                locale: window.locale,
            }));
            storeManager.dispatch(
                sessionActions.setQuestionSetIdentifier('assessmentRunId', window.offlineQuestionSet.assessmentRunId)
            );

            storeManager.dispatch(sessionActions.setSessionInfo(startTest));
            storeManager.dispatch(settingsActions.settingsLoadSuccess(allSettings));
            storeManager.dispatch(assessmentActions.assessmentLoadSuccess(assessment));
            storeManager.dispatch(apiActions.setApiConnectionStatus(connectionStatusConstants.OFFLINE_MODE));

            setTimeout(() => {
                storeManager.dispatch(sessionActions.setAppReady());

                navigationService.navigateToStartingPoint();
                if (!localCache.isLocalStorageAvailable()) {
                    alertService.showAlert(t('session.localStorageUnavailable'));
                }
            }, 1000);
        });
    },
};

export default offlineDataLoader;
